import { LayoutDashboard, Users, Wallet, CalendarDays, ReceiptText } from 'lucide-react';

export const BAILLEUR_LINKS = [
  { to: '/bailleur', end: true, label: 'Tableau de bord', icon: LayoutDashboard },
  { to: '/bailleur/locataires', label: 'Locataires', icon: Users },
  { to: '/bailleur/paiements', label: 'Paiements', icon: ReceiptText },
  { to: '/bailleur/calendrier', label: 'Calendrier', icon: CalendarDays },
  { to: '/bailleur/abonnement', label: 'Mon abonnement', icon: Wallet },
];
